module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600italic-fa071664f519e9e9409d8a6614b7c854.woff2";